import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';

import { Dashboard as DashboardLayout } from 'layouts';


// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing(2)
  },
  item: {
    height: '100%'
  }
});

class Projects extends Component {
  render() {
    const { classes, title, children, menu, breadcrumbs, breadcrumbsObject, isLoading } = this.props;
    
    return (
      <DashboardLayout 
        specialMenu={menu}
        title={title}
        breadcrumbs={breadcrumbs}
        breadcrumbsObject={breadcrumbsObject}
        isContentLoading={isLoading}
      >

        <div className={classes.root} style={{ maxWidth: '1200px' }}>
          {children}
        </div>

      </DashboardLayout>
    );
  }
}

export default withStyles(styles)(Projects);